import React from 'react'
import BaseComponent from "../../pages/base/BaseComponent";
import {Button, Card, OverlayTrigger, Table, Tooltip} from "@themesberg/react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faInfo} from "@fortawesome/free-solid-svg-icons";
import label from "enqc-utilities/src/label/Label"
import {Link} from "react-router-dom";
import {Routes} from "../../routes";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {getUser} from "../../utils/StorageUtil";
import PropTypes from 'prop-types';
import PaginationTable from "../../components/PaginationTable";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import MyImage from "../../components/MyImage";
import GoodsItemDetailPage from "./GoodsItemDetailPage";
import GoodsInfoViewModal from "../../components/GoodsInfoViewModal";
import SmartDeviceInfoModal from "../../components/SmartDeviceInfoModal";
import {parseDate} from "enqc-utilities/src/utils/Utilities";
import {DD_MMMM_YYYY_HH_MM_SS} from "../../utils/Global";


class GoodsItemTable extends BaseComponent{

    constructor(props) {
        super(props);
        this.state = {
            show:false,
            inputSearch: "",
            user : getUser(),
            selectedGoodsInfo:undefined,
            selectedSmartDeviceInfo:{},
            sortOption:props.sortOption?props.sortOption:{},
            goodsItemStatus:props.goodsItemStatus?props.goodsItemStatus:{},
            tabDataCallback:props.tabDataCallback?props.tabDataCallback:{},
            page: 1,
            goodsItems:[],
            totalPage: 0,
            totalElement: 0,
            pageElement: 0
        }
    }
    componentDidMount() {
        super.componentDidMount();
        this.fetchGoodsItems(undefined, undefined, undefined, undefined, this.state.sortOption)
    }

    componentWillReceiveProps(props, nextContext) {
        let show = props.show?props.show:false
        let goodsItemStatus = props.goodsItemStatus?props.goodsItemStatus:{}
        let tabDataCallback = props.tabDataCallback?props.tabDataCallback:{}
        this.setState({show, goodsItemStatus, tabDataCallback},() => {
            if(show && !this.props.show){
                this.fetchGoodsItems(undefined, undefined, undefined, undefined, this.state.sortOption)
            }
        })
    }

    goToPage(page){
        this.setState({page}, () => {
            this.refresh()
        })
    }

    refresh(){
        let {search, filteredSmartDevices, filteredUsers, filteredGoodsCategories, sortOption} = this.state
        this.fetchGoodsItems(search, filteredSmartDevices, filteredUsers, filteredGoodsCategories, sortOption)
    }


    fetchGoodsItems = (search, filteredSmartDevices, filteredUsers, filteredGoodsCategories, sortOption) => {
        let {user, goodsItemStatus, goodsItems, tabDataCallback} = this.state
        let filterSmartDeviceIds = undefined
        if(filteredSmartDevices){
            filterSmartDeviceIds = new Array()
            filteredSmartDevices.forEach((item)=>{
                filterSmartDeviceIds.push(item.id)
            })
        }
        let filterUserIds = undefined
        if(filteredUsers){
            filterUserIds = new Array()
            filteredUsers.forEach((item)=>{
                filterUserIds.push(item.id)
            })
        }
        let filterGoodsCategoryIds = undefined
        if(filteredGoodsCategories){
            filterGoodsCategoryIds = new Array()
            filteredGoodsCategories.forEach((item)=>{
                filterGoodsCategoryIds.push(item.id)
            })
        }
        this.setState({
            search, filteredSmartDevices, filteredUsers, filteredGoodsCategories, sortOption
        }, () => {
            this.get(Endpoint.API.GOODS_ITEMS, {
                params :{
                    goodsItemStatusId : goodsItemStatus.id==0?undefined:goodsItemStatus.id,
                    ascending: sortOption.ascending,
                    sortir: sortOption.sortir,
                    search: search,
                    filteredSmartDeviceIdStrings:JSON.stringify(filterSmartDeviceIds),
                    filteredUserIdStrings:JSON.stringify(filterUserIds),
                    filteredGoodsCategoryIdStrings:JSON.stringify(filterGoodsCategoryIds),
                    page: this.state.page - 1,
                }
            }, null, response=>{
                if(response.code===200){
                    let goodsItems = response.data
                    let totalPage = response.totalPage
                    let totalElement = response.totalElement
                    let pageElement = response.pageElement
                    this.setState({goodsItems:goodsItems,totalPage, totalElement, pageElement}, () => {
                        if(tabDataCallback){
                            tabDataCallback(goodsItemStatus.id, totalElement)
                        }
                    })
                }
            }, true, true)
        })
    }


    render() {
        let {user, selectedGoodsInfo, selectedSmartDeviceInfo, goodsItems, page, pageElement, totalPage, totalElement} = this.state
        return (
            <React.Fragment>
                <GoodsInfoViewModal
                    show={selectedGoodsInfo!==undefined}
                    goodsInfo={selectedGoodsInfo}
                    onClose={() => {
                        this.setState({selectedGoodsInfo:undefined})
                    }}
                    showProcessing={this.props.showProcessing}
                    closeProcessing={this.props.closeProcessing}
                />
                <SmartDeviceInfoModal {...this.props}
                                      onClose={() => {
                                          this.setState({selectedSmartDeviceInfo:{}})
                                      }}
                                      show={selectedSmartDeviceInfo.id}
                                      smartDevice={selectedSmartDeviceInfo}/>
                <Card border="light" className="table-wrapper table-responsive shadow-sm">
                    <Card.Body className="p-0">
                        <Table hover className="table-sm align-items-center p-0">
                            <thead>
                            <tr>
                                <th className="border-bottom">#</th>
                                <th className="border-bottom">{label.Goods}</th>
                                <th className="border-bottom">{label.GoodsCategory}</th>
                                <th className="border-bottom">{label.RFIDTag}</th>
                                <th className="border-bottom">{label.LastAllocation}</th>
                                <th className="border-bottom">{label.Status}</th>
                                <th className="border-bottom">{label.RegistrationDate}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {goodsItems.map((goodsItem, index) => (
                                <tr key={index}>
                                    <td>
                                        <Card.Link as={Link} to={Routes.Invoice.path} className="fw-normal">
                                            {((page - 1) * pageElement) + (index+1)}
                                        </Card.Link>
                                    </td>
                                    <td>
                                        <span className="fw-normal">
                                            <Link
                                                style={{textDecoration:'underline'}}
                                                onClick={() => {
                                                    this.setState({selectedGoodsInfo:goodsItem.goodsInfo})
                                                }}
                                                to="#">
                                                {goodsItem.goodsInfo.name}
                                            </Link>
                                        </span>
                                    </td>
                                    <td>
                                        <span className="fw-normal">
                                            {goodsItem.goodsInfo.goodsCategory.name} &nbsp;
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip id="tooltip-id">{goodsItem.goodsInfo.goodsCategory.description}</Tooltip>}>
                                                <Button
                                                    variant="outline-success"
                                                    className="p-0" size="sm"
                                                    style={{width:'21px', height:'21px'}}>
                                                <FontAwesomeIcon size="sm" className="super-badge m-0" icon={faInfo}/>
                                                </Button>
                                            </OverlayTrigger>
                                        </span>
                                    </td>
                                    <td>
                                        <Link
                                            style={{textDecoration:'underline'}}
                                            to={GoodsItemDetailPage.ENDPOINT+"/"+goodsItem.id}>
                                            {goodsItem.rfidTag}
                                        </Link>
                                    </td>
                                    <td>
                                        <Button
                                            size="sm"
                                            variant={goodsItem.lastPhysicalContainerLocation?"outline-primary":"outline-danger"}
                                            className="fw-normal btn-outline-white"
                                            onClick={event => {
                                                this.setState({selectedSmartDeviceInfo:goodsItem.lastSmartDeviceLocation})
                                            }}
                                            style={{color:goodsItem.goodsItemStatus.color, borderColor:goodsItem.goodsItemStatus.color}}>
                                            <MyImage src={goodsItem.goodsItemStatus.insideMachine?ApplicationIcons.Icons.allocatedGreen:ApplicationIcons.Icons.notAllocated} style={{width:'24px'}} />&nbsp;
                                            {goodsItem.lastPhysicalContainerLocation?goodsItem.lastPhysicalContainerLocation.deviceId:label.NotYetAllocated}
                                        </Button>
                                    </td>
                                    <td>
                                        <Button
                                            size="sm"
                                            className="fw-normal btn-outline-white"
                                            disabled={true}
                                            style={{color:goodsItem.goodsItemStatus.color, borderColor:goodsItem.goodsItemStatus.color}}>
                                            {goodsItem.goodsItemStatus?label(goodsItem.goodsItemStatus.label):"-"}
                                        </Button>
                                    </td>
                                    <td>
                                        <span>{parseDate(goodsItem.created, DD_MMMM_YYYY_HH_MM_SS)}</span>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                    <PaginationTable
                        onSelect={(page) => {
                            this.goToPage(page)
                        }}
                        showingRow={goodsItems.length}
                        currentPage={page}
                        pageCount={totalPage}
                        totalElement={totalElement}/>
                </Card>
            </React.Fragment>
        );
    }

}
GoodsItemTable.propTypes = {
    show:PropTypes.bool.isRequired,
    goodsItemStatus:PropTypes.any.isRequired,
    sortOption:PropTypes.object,
    tabDataCallback:PropTypes.func
}


export default GoodsItemTable